export const auszahlungsgrenzeEinheit = {
  euro: 'euro',
  stunden: 'stunden',
} as const;

export type AuszahlungsgrenzeEinheit = keyof typeof auszahlungsgrenzeEinheit;
